import { Controller } from '@hotwired/stimulus'
import { disable } from 'helpers/custom_events_helper'

export default class extends Controller {
  static targets = ['discard']

  clearUploadId(event) {
    event.preventDefault()

    // currentTarget is the <a> the action is bound to (the galette button-link),
    // not the inner element that received the click.
    const link = event.currentTarget

    // Already in flight (loading) or disabled (cells still processing).
    if (link.classList.contains('button--loading') || link.classList.contains('button--disabled')) { return }

    // Capture the destination before disabling, since galette:disable strips the href.
    const href = link.getAttribute('href')

    // Mark loading synchronously so an immediate second click is a no-op, then
    // disable via the galette ui--link event API. Also disable the discard button
    // so it can't be used mid-submission.
    link.classList.add('button--loading')
    disable(link)
    if (this.hasDiscardTarget) { disable(this.discardTarget) }

    const url = new URL(window.location.href)
    url.searchParams.delete('upload_id')
    window.history.replaceState(history.state, '', url)

    Turbo.visit(href)
  }
}
